import { queryApi } from "src/utils/api/ApiMethods"

export const queryQuantitiesSold = async ({ marinaSlug, from, to }) => {
  const url = `/manage/${marinaSlug}/fuel/quantities_sold?from=${from.toJSON()}&to=${to.toJSON()}`

  return queryApi(url)
}
